<template>
  <section>
    <img src="../../assets/images/qr_code.svg" alt="img-pix" width="200px" height="200px">
    <p class="mt-0 bold">Chave Pix: 40.125.948/0001-98</p>    
    <p class="mt-3 text-center mt-0">
      Atenção: Após realizar o pagamento via PIX, enviar o comprovante e número do pedido para o 
      email ou para um de nossos números de whatsapp abaixo.
      
      <span class="whatsapp mt-2">
        <img src="../../assets/images/gmail.png" alt="email" width="22px" height="22px"> 
        <a href="mailto:atendimento@sistransce.com.br" class="ml-1 mr-1" target="_blank">atendimento@sistransce.com.br</a>
        
        <em class="ml-1 mr-2">-</em>
        
        <img src="../../assets/images/whatsapp.png" alt="whatsapp" width="22px" height="22px"> 
        <a href="https://wa.me/558530937801" class="ml-1" target="_blank">(85) 3093-7801</a> 
        
        <em class="ml-1 mr-2">-</em>
      
        <img src="../../assets/images/whatsapp.png" alt="whatsapp" width="22px" height="22px"> 
        <a href="https://wa.me/558530937802" class="ml-1" target="_blank">(85) 3093-7802</a>
      </span>
    </p>

    <v-btn
      depressed
      color="success"
      id="form-checkout__submit"
      type="button"
      block
      @click.prevent="doPayment()"
      >Finalizar Pagamento</v-btn
    >
  </section>
</template>

<script>
import { DEFAULT_EMAIL_PAYMENT } from "@/commons/config";
export default {
  name: "PaymentPix",
  props: {
    paymentCartaoIndendificationNumber: {
      type: String,
      required: true,
      default: ""
    },
    paymentCartaoIndendificationValue: {
      type: Number,
      required: true,
      default: 0
    }
  },
  methods: {
    doPayment() {
      const paymentData = {
        amount: String(this.paymentCartaoIndendificationValue),
        cardholderEmail: DEFAULT_EMAIL_PAYMENT,
        identificationNumber: this.paymentCartaoIndendificationNumber,
        identificationType: "CNPJ",
        installments: null,
        issuerId: "",
        merchantAccountId: null,
        paymentMethodId: "pix",
        processingMode: null,
        token: ""
      };
      this.$emit("doPayment", paymentData);
    }
  }
};
</script>

<style lang="scss" scoped>
.bold{
  font-weight: bold;
}

.whatsapp {
  display: flex;
  align-items: center;
  justify-content: center;

  & a {
    text-decoration: none;
    color: #000;
  }
}
</style>
